import { Component, Input, ChangeDetectionStrategy, Injector } from '@angular/core'
import { Store } from '@ngrx/store'
import { NavController } from 'ionic-angular'
import { UIEventHub } from '../../../services/event.service'
import { ActionCreator } from '../../../services/action.service'
import { ViewModel } from '../../../view-model'
import { BaseWidget } from '../../base-widget'
import { ColorCodeInterface, ColorTip } from'@ar2/common';
/**
 * カラーコード
 *【色:hex:string】
 *【ボーダー色:borderColor:string】
 *【フォント色:isTextLight:boolean】
 *【カラーコード:code:string】
 *【内容:description:string】
 *【表示条件:visible:boolean】
 * @author nabla2.metamodel.generator
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-color-code',
  templateUrl: './color-code.html',
  styles: [`
    
  `]
})
export class ColorCode extends BaseWidget {
  /**
   * 色
   */
  @Input() hex:string

  /**
   * ボーダー色
   */
  @Input() borderColor:string

  /**
   * フォント色
   */
  @Input() isTextLight:boolean

  /**
   * カラーコード
   */
  @Input() code:string

  /**
   * 内容
   */
  @Input() description:string

  /**
   * 表示条件
   */
  @Input() visible:boolean

  /**
   * コンストラクタ
   * @param navCtrl 画面遷移管理サービス
   * @param store Reduxストア
   */
  constructor(
    public navCtrl: NavController,
    public store: Store<{viewModel:ViewModel}>,
    public eventHub: UIEventHub,
    public actionCreator: ActionCreator,
    public injector: Injector,
  ) {
    super(injector)
  }
  public getColorCode() {
    let color = {} as  ColorCodeInterface;
    if (this.hex) {
      color = {
        hex: this.hex,
        code: this.code,
        description:this.description ,
        borderColor: this.borderColor,
        isTextLight: this.isTextLight
      };
      return color;
    } else {
      return color;
    }
  }
    
  public getColorTip() {
    const color:ColorTip = {
      code: this.code,
      name: this.description
    };
    return color;
  }
}


// WEBPACK FOOTER //
// ./src/widgets/color_code/color-code/color-code.component.ts